import { Component,AfterViewInit, OnInit,EventEmitter,Output,Input, TemplateRef, ViewChild, ElementRef, ChangeDetectorRef, ViewChildren, QueryList, NgZone } from '@angular/core';import { MatDialog } from '@angular/material/dialog';
import { FormsService } from '../../applicationModules/eSignature/services/forms.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-portalpdfupload',
  templateUrl: './portalpdfupload.component.html',
  styleUrls: ['./portalpdfupload.component.scss']  
})

export class PortalPDFUploadComponent  implements OnInit {  
   selectedFile: File | null = null;
   spinner: boolean = false;
   fileUploaded:boolean=false;
   portalEmail:string="";
   @ViewChild('Input') InputFile: ElementRef;
   subscription: Subscription;
   pageRefresh:boolean=false;  
   showUploadBox: boolean = true;

   constructor(private formsService:FormsService,
    private loaderService: LoaderService,private toastr: ToastrService,
    private cdr: ChangeDetectorRef, private statusConstant: StatusConstant,private ngZone: NgZone) {     

     }  
   
       
  ngOnInit() {
     this.portalEmail=sessionStorage.getItem('portalemail');
     //Call API immediately and then every 10 sec (300000 ms)
     this.subscription = interval(10000).subscribe(() => {
       if (this.pageRefresh == true) {
        const portalDocumentID = Number(sessionStorage.getItem('portaldocumentID'));
        if(portalDocumentID>0){
          this.GetStatusisDocReadyforSign(portalDocumentID);
         }
       }
     });
     this.showUploadBox=true;
     const portalDocumentID = Number(sessionStorage.getItem('portaldocumentID'));
     if (!isNaN(portalDocumentID)) {
        if(portalDocumentID>0){
         this.GetStatusisDocReadyforSign(portalDocumentID);
        }else{
       this.showUploadBox=true;
       this.cdr.detectChanges();
     }  
     }else{
      this.showUploadBox=true;
      this.cdr.detectChanges();
     } 
    
  }   

 
   selectFilesForWithoutParentId(event: Event, fileInput: HTMLInputElement) {   
    this.loaderService.show();
    this.spinner =true;
    const input = event.target as HTMLInputElement;
    if (!input.files) {
      this.toastr.error('No files selected.', '', { timeOut: 3000 });
      this.loaderService.hide();
      return;
    }
    

     const chunkSize = 10 * 1024 * 1024; // 5 MB per chunk
     const UploadedFilesDragZone = Array.from(input.files); // Convert FileList to Array

     const processFile = async (file: File) => {
      // Remove brackets, hash, comma, and special characters except underscore and dot (for file extension)
      const fileName = file.name.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

      // Validate file name length
      if (fileName.split('.')[0].length > 120) {
        this.toastr.warning(
          'File name up to 120 characters only supported, please rename the file.',
          '',
          { timeOut: 3000 }
        );
        fileInput.value = '';
        //this.InputFile.nativeElement.value = '';
        this.loaderService.hide();
        this.spinner =false;
        return;
      }
     
      var newfilename = fileName.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
     
      var documentNameSplit = newfilename.split('.');    

      const documentName = documentNameSplit[0];
      const documentType = documentNameSplit[1];

      const totalChunks = Math.ceil(file.size / chunkSize);

      let intervalId: any;
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append('fileChunk', chunk);
        formData.append('chunkIndex', i.toString());
        formData.append('totalChunks', totalChunks.toString());
        formData.append('fileName', fileName);
        formData.append('FileDetailList', `${documentName}|${documentType}`);
        formData.append('ParentID', ('0'));
        formData.append('email', this.portalEmail.toString());       
        try {          
          this.fileUploaded=false;
          this.showUploadBox=false;     
          this.message="We are going to process this document to be ready for signature, Please Wait..";

          const response = await this.formsService.uploadPortalDocinChunks(formData).toPromise();
          if (response?.data === 2) {
            this.fileUploaded=true;
            this.showUploadBox=true; 
            this.toastr.warning(`${fileName} already exists.`, '', {
            timeOut: 2000,
           });
          } else {
            if (i + 1 == totalChunks) {
             intervalId = this.showEngagingToaster(fileName);
             }
            this.toastr.clear();
            this.toastr.info(`Chunk ${i + 1}/${totalChunks} uploaded for ${fileName}`, '', {
            timeOut: 1000,
           });   
           this.spinner =false;
           sessionStorage.setItem('portaldocumentID', response.data);
           this.GetStatusisDocReadyforSign(response.data);
          //  sessionStorage.setItem('portaldocumentID', response.data);
          //  sessionStorage.setItem('portalemail', this.portalEmail);
          //  var url = window.location.href.split(window.location.pathname)[0] + "/request/portalsignature";
          //  window.location.href = url;
          // window.open(url, "_blank");
          }
        } catch (error) {
          this.spinner =false;
          this.loaderService.hide();
          this.toastr.error(`An error occurred during chunk upload for ${fileName}.`, '', {
            timeOut: 3000,
          });
          return;
        }
      }
      if (intervalId)
        if( this.fileUploaded==false){
         this.clearEngagingToaster(intervalId, `File ${fileName} uploaded successfully!`);       
        }
    };

    const uploadFiles = async () => {
      for (const file of UploadedFilesDragZone) {
        await processFile(file);
      }
      fileInput.value = '';
      this.loaderService.hide();
      this.spinner =false;
    };

    uploadFiles();
  }

   clearEngagingToaster = (intervalId: any, finalMessage: string) => {
    clearInterval(intervalId); // Stop the interval updates
    this.toastr.clear(); // Clear the previous toast
    this.toastr.success(finalMessage, '', { timeOut: 3000 }); // Show the success message
  };

   engagingMessages = [
    "Hang tight, we're uploading your file!",
    "Almost there! Your data is on its way.",
    "We’re making progress. Just a bit more patience!",
    "Your file is getting uploaded smoothly.",
    "Crunching data… great things take time!",
    "Uploading… this won’t take long!",
  ];

  showEngagingToaster = (fileName: string) => {
    let messageIndex = 0;
    const toastId = `upload-progress-${fileName}`;

    // Update the engaging message periodically
    const intervalId = setInterval(() => {
      if (messageIndex < this.engagingMessages.length) {
        this.toastr.clear();
        this.toastr.info(this.engagingMessages[messageIndex], '', {
          disableTimeOut: true,
          closeButton: true,
        });
        messageIndex++;
      } else {
        // Loop the messages once all are shown
        messageIndex = 0;
      }
    }, 5000); // Change message every 2 seconds

    return intervalId;
  };

  isDragging = false;

  onDrop(event: DragEvent): void {
  event.preventDefault();
  this.isDragging = false;

  if (event.dataTransfer?.files.length) {
    const file = event.dataTransfer.files[0];
   // this.handleSelectedFile(file);
  }
}

onDragOver(event: DragEvent): void {
  event.preventDefault();
  this.isDragging = true;
}

onDragLeave(event: DragEvent): void {
  event.preventDefault();
  this.isDragging = false;
}

ResponseHolderDetails:any=[]=[];
message:string="";

 GetStatusisDocReadyforSign(portaldocumentID) { 
  const reqModel = {
    documentID: Number(portaldocumentID),   
  };  
  this.loaderService.show();
  this.formsService.getStatusisDocReadyforSign(reqModel).subscribe((response) => {
    if(response != undefined) {
        this.ResponseHolderDetails = response;       
        if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {  
          if(this.ResponseHolderDetails.data==0){
           this.pageRefresh=true;   
           this.showUploadBox=false;     
           this.message="We are going to process this document to be ready for signature, Please Wait..";
          } 
          if(this.ResponseHolderDetails.data==1){
           this.pageRefresh=true;    
           this.showUploadBox=false;     
           this.message="Document getting ready for Signature, Please Wait..";         
          } 
          if(this.ResponseHolderDetails.data==3){      
            this.pageRefresh=false;   
            var url = window.location.href.split(window.location.pathname)[0] + "/request/portalsignature";
            window.location.href = url;        
          }        
        } else {   
          this.pageRefresh=false;        
        }
      } else {        
      }
    });
}

  // onFileSelected(event: Event) {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files?.length) {
  //     this.selectedFile = input.files[0];
  //   }
  // }

  // onDragOver(event: DragEvent) {
  //   event.preventDefault();
  // }

  // onDrop(event: DragEvent) {
  //   event.preventDefault();
  //   if (event.dataTransfer?.files?.length) {
  //     this.selectedFile = event.dataTransfer.files[0];
  //   }
  // }


}